import axios from 'axios';
import { charsheetAPI } from '../globals.js';

const getCampaignData = async (campaignName) => {
    if (!campaignName) return null;
    try {
        const API_URL = `${charsheetAPI}?TableName=charsheet-campaigns&CampaignName=${campaignName}`;
        const res = await axios.get(API_URL);
        return res.data || null;
    } catch (error) {
        console.error('Error fetching campaign data:', error);
        return null;
    }
};

export default getCampaignData;
